import { render, staticRenderFns } from "./ChartWidget.vue?vue&type=template&id=1fcf69b1&scoped=true"
import script from "./ChartWidget.vue?vue&type=script&lang=js"
export * from "./ChartWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcf69b1",
  null
  
)

export default component.exports